import { useParams } from "react-router-dom";
import CandidateDetailsHeader from "./components/CandidateDetailsHeader";
import CandidateDetailsContent from "./components/CandidateDetailsContent";
import useCandidate from "../../Hooks/useCandidate";
import "./index.scss";

const CandidateDetails = () => {
  const { candidateId } = useParams<{ candidateId: string }>();
  const { candidate, recentApplication, recentResume } = useCandidate(
    candidateId || null,
  );

  return (
    <div className="candidate-details-page">
      <CandidateDetailsHeader />
      <CandidateDetailsContent
        candidate={candidate}
        recentApplication={recentApplication}
        recentResume={recentResume}
      />
    </div>
  );
};

export default CandidateDetails;
